import { type BlockDefinition, isDetailsBlock, blockIsMapped } from "@softr-io/blocks-sdk";

export function findFirstMappedDetailsBlock(definitions: readonly BlockDefinition[]): BlockDefinition | null {
    const visitedSet = new Set<string>();
    const blocksById = Object.fromEntries(definitions.map((def) => [def.id, def]));
    for (const def of definitions) {
        const foundDetails = visit(def);
        if (foundDetails) return foundDetails;
    }
    return null;
    function visit(def: BlockDefinition): BlockDefinition | null {
        if (visitedSet.has(def.id)) return null;
        visitedSet.add(def.id);
        if (isDetailsBlock(def) && blockIsMapped(def)) {
            return def;
        }
        if (def.type === "container") {
            for (const slot of def.container.slots) {
                if (!slot.blockId) continue;
                const childBlock = blocksById[slot.blockId];
                if (childBlock) {
                    const found = visit(childBlock);
                    if (found) return found;
                }
            }
        }
        return null;
    }
}
